/**
 * Created by yangxuanbin on 07/02/2018
 **/
const initialAuthState = {};
export default function positionInfo(state=initialAuthState, action){
    switch (action.type){
    case "SET_POSITIONS":
      return{
          ...state,
          ...action.data,
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reduxModule/reducers/positionInfo.js